import { AuthLayout } from '../Layouts/AuthLayout.tsx';
import { Center } from '@mantine/core';
import { useEffect } from 'react';
import { redirectToUrlOrLegacyHome } from './Logic/Rutas.ts';

export function Ingresando() {
    useEffect(() => {
        const url = new URL(window.location.href);
        const redirectTo = url.searchParams.get('redirectTo');
        redirectToUrlOrLegacyHome(redirectTo);
    }, []);
    return (
        <AuthLayout>
            <Center>Ingresando</Center>
        </AuthLayout>
    );
}
